import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  useTheme,
  Grid,
  Paper,
  Button,
  Snackbar,
} from "@mui/material";
import { Email, Phone, ConfirmationNumber } from "@mui/icons-material";
import { IRaffle } from "../../../store/interfaces/IRaffle";
import { useGetLastActiveRaffleQuery, useGetTop10PurchasersQuery, useGetTopPurchasersQuery } from "../../../store/api";

interface PromoEngineProps {
  raffle: IRaffle;
}

export const PromoEngine = ({ raffle }: PromoEngineProps) => {
  // const showPremiumAlert = !raffle.isPremium;
    const showPremiumAlert = true;
    const {
      data: lastActiveRaffleFounded,
    } = useGetLastActiveRaffleQuery(raffle.accountId, {
      skip: raffle.accountId === "default",
    });
  
  const {
    data: topPurchasersFounded = [],
    isLoading,
  } = useGetTop10PurchasersQuery(lastActiveRaffleFounded?.id || "", {
    skip: raffle.id === "default" || showPremiumAlert || !lastActiveRaffleFounded,
    refetchOnReconnect: true,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);

  const handleSendEmails = () => {
    console.log("🚀 Enviando correos a:", topPurchasersFounded);
    setSnackbarOpen(true);
    // Aquí puedes conectar a una mutación real
  };

  return (
    <Card
      sx={{
        mx: "auto",
        p: 3,
        borderRadius: 3,
        boxShadow: 4,
        maxWidth: 1000,
        textAlign: "center",
      }}
    >
      <CardContent
        sx={{
          position: "relative",
          minHeight: 300,
          overflow: "hidden",
        }}
      >
        {showPremiumAlert && (
          <>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backdropFilter: "blur(2px)",
                zIndex: 1,
              }}
            />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
                backgroundColor: "black",
                border: `2px solid white`,
                borderRadius: 2,
                padding: 4,
                boxShadow: 6,
                textAlign: "center",
                maxWidth: 420,
              }}
            >
              <Typography variant="h6" color="warning.main" gutterBottom>
                🔧 Funcionalidad En Desarrollo
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Con esta herramienta puedes diseñar promociones personalizadas para incentivar la compra de tickets.
                Flexibiliza tus campañas, premia a tus mejores compradores y aumenta tus ventas con promociones inteligentes y automáticas.
              </Typography>
            </Box>
          </>
        )}

        <Typography variant="h5" color="primary" gutterBottom>
          ✉️ Mejores compradores
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          Estos son los <strong>10 compradores más activos</strong> de la rifa  <strong>{lastActiveRaffleFounded?.name}</strong>.
        </Typography>

        {isLoading ? (
          <Typography variant="body2" color="text.secondary">
            Cargando compradores destacados...
          </Typography>
        ) : topPurchasersFounded.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            Aún no hay compradores destacados.
          </Typography>
        ) : (
          <>
            <Grid container spacing={2} justifyContent="center">
              {topPurchasersFounded.map((buyer, index) => (
               <Grid item xs={12} sm={6} md={5} key={index}>
               <Paper
                 elevation={3}
                 sx={{
                   p: 2,
                   borderRadius: 2,
                   textAlign: "left",
                 }}
               >
                 {/* Name + Phone in one line */}
                 <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                   <Typography variant="subtitle1" fontWeight="bold">
                     {buyer.name}
                   </Typography>
                   <Typography variant="body2" sx={{ display: "flex", alignItems: "center" }}>
                     <Phone fontSize="small" sx={{ mr: 0.5 }} /> {buyer.phone}
                   </Typography>
                 </Box>
             
                 {/* Ticket count */}
                 <Typography
                   variant="body2"
                   sx={{ display: "flex", alignItems: "center", mt: 1 }}
                 >
                   <ConfirmationNumber fontSize="small" sx={{ mr: 1 }} /> {buyer.ticketCount} tickets
                 </Typography>
               </Paper>
             </Grid>
             
              ))}
            </Grid>

            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 4, px: 4, py: 1.5, fontWeight: "bold", fontSize: "1rem" }}
              disabled
              onClick={handleSendEmails}
            >
              Enviar correo promocional
            </Button>
          </>
        )}
      </CardContent>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        message="✅ Correos enviados exitosamente"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </Card>
  );
};
